module.exports = __webpack_public_path__ + "img/sidik-fofana.331f0b81.png";